import { ServiceLevelRia, ServiceLevelUpgradeMapping } from 'types/upgrade';
import { investmentEntityRequest } from '@utils/request';

export const getServiceLevelUpgradeData = async (): Promise<ServiceLevelUpgradeMapping> => {
	const response = await investmentEntityRequest.get(`/service-level-upgrade-mapping`);
	return response.data;
};

export const upgradeServiceLevelAndRiaPlan = async (upgradeInfo: ServiceLevelRia): Promise<void> => {
	await investmentEntityRequest.post(`/service-level/upgrade`, upgradeInfo);
};
